import { createContext } from "react";

export const StepContext = createContext<number>(-1);